var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{attrs:{"sendType":_vm.sendType,"system":_vm.system}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }